export function abbreviateIntentNumber(value: number): string {
    if (!value) {
        return '0';
    }

    if (value < 1000) {
        return value.toString();
    }

    if (value >= 1000 && value < 1000000) {
        return formatWithCustomRounding(value / 1000, 'k');
    }

    if (value >= 1000000) {
        return formatWithCustomRounding(value / 1000000, 'M');
    }

    return value.toString();
}

function formatWithCustomRounding(abbreviated: number, suffix: string): string {
    let integerPart = Math.floor(abbreviated);
    const decimalPart = abbreviated - integerPart;
    const decimalStr = decimalPart.toFixed(3).substring(2);
    
    let firstDecimal = parseInt(decimalStr[0]);
    let secondDecimal = parseInt(decimalStr[1]);
    let thirdDecimal = parseInt(decimalStr[2]);
    
    // Check third digit
    if (thirdDecimal > 5) {
        secondDecimal++;
    }
    
    // Check second digit
    if (secondDecimal > 5) {
        firstDecimal++;
    }
    
    // Check if first decimal digit becomes 10
    if (firstDecimal >= 10) {
        integerPart++;
        firstDecimal = 0;
    }
    
    return integerPart + '.' + firstDecimal + suffix;
}